import { lazyWithPreload } from 'helpers/lazyWithPreload'

export const SkinTypeExplanation = lazyWithPreload(
  () => import('./SkinTypeExplanation'),
)
